import App from '../App'

const alert = r => require.ensure([], () => r(require('../components/AlertPage')), 'alert')
// const question = r => require.ensure([], () => r(require('../components/QuestionPage')), 'question')

export default [{
    path: '/',
    component: App, //顶层路由，对应index.html
    children: [ //二级路由。对应App.vue
        //地址为空时跳转home页面
        {
            path: '',
            redirect: '/alert'
        },

        //报警页面
        {
            path: '/alert',
            component: alert
        },
      //
      // //考试答案页面
      // {
      //   path: '/question',
      //   component: question
      // }
    ]
}]



// WEBPACK FOOTER //
// ./src/router/router.js